function Wallet({ style }) {
  const { fill = '#9191A8', width = 24, height = 24 } = style || {};
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fill}
        d="M19.7 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.7 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.7 4.5ZM3.95 9h16.5v1.5H15.2a.75.75 0 0 0-.75.75 2.25 2.25 0 1 1-4.5 0 .75.75 0 0 0-.75-.75H3.95V9Zm.75-3h15a.75.75 0 0 1 .75.75v.75H3.95v-.75A.75.75 0 0 1 4.7 6Zm15 12h-15a.75.75 0 0 1-.75-.75V12h4.574a3.75 3.75 0 0 0 7.35 0h4.575v5.25a.75.75 0 0 1-.75.75Z"
      />
    </svg>
  );
}

export default Wallet;
